import { ILogService } from '../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';

export class SchedulerRouterHelper {
  constructor(private $state: ng.ui.IStateService, private $timeout: ng.ITimeoutService, private log: ILogService) {}

  navigateFromRouter(
    deferred: angular.IDeferred<any>,
    stateName?: ng.ui.IState['name'],
    parameters?: object,
    options?: object
  ) {
    if (!stateName || _4.isEmpty(stateName)) {
      return deferred.resolve();
    }

    const TIME_TO_FIX_ANGULAR_STATE_ERROR = 10;

    // when navigation failed, we show error notification which we don't want here
    this.log.disable();

    this.$timeout(() => {
      this.log.enable();
      this.$state.go(stateName, parameters, options);
    }, TIME_TO_FIX_ANGULAR_STATE_ERROR);

    deferred.reject();
  }
}

angular.module('capability-ng-scheduler').service('ngSchedulerRouterHelper', SchedulerRouterHelper);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/standalone_scheduler/helpers/router_helper.ts